export const DIFF_STATUS = {
    UNCHANGED: "unchanged",
    ADDED: "added",
    MODIFIED: "modified",
    DELETED: "deleted",
};

export const DIFF_STATUS_META = {
    [DIFF_STATUS.UNCHANGED]: { label: "未变", tone: "unchanged" },
    [DIFF_STATUS.ADDED]: { label: "新增", tone: "added" },
    [DIFF_STATUS.MODIFIED]: { label: "修改", tone: "modified" },
    [DIFF_STATUS.DELETED]: { label: "删除", tone: "deleted" },
};

export function createDiffCountMap() {
    return {
        [DIFF_STATUS.UNCHANGED]: 0,
        [DIFF_STATUS.ADDED]: 0,
        [DIFF_STATUS.MODIFIED]: 0,
        [DIFF_STATUS.DELETED]: 0,
    };
}
